var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('back-btn'),_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"lg":"10"}},[_c('v-card',{staticClass:"card--shadow"},[_c('counseling-form',{on:{"emitData":_vm.createCounseling}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }